import template from './component.tpl.html';
import './controller';

/**
 * @ngdoc component
 * @name bo.component:bo-meta-list
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="components">
 <file name="index.html">
 <bo-meta-list meta-list="[]"></bo-meta-list>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.components')
    .component('boMetaList', {
        bindings: {
            metaList: '<'
        },
        controller: 'BoMetaListController',
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/bo/components/meta-list/component.js